import { removeByPath } from "../../../utility";
import { ArsContextState, IArsActionRemoveItem } from "../interface";
import { addPatchToStack } from "./addPatchToStack";

/**
 * Removes an item at a JSON-pointer path.
 *
 * @param state - Current ARS context state
 * @param action - Remove-item action
 * @returns Updated state with removal and patch metadata
 */
export const arsc_removeArsItem = <T>(
  state: ArsContextState<T>,
  action: IArsActionRemoveItem,
): ArsContextState<T> =>
  addPatchToStack(
    state,
    removeByPath({ ...state, changed: true }, action.dataPath, action.newLength),
  );
